// dialog.service.ts
import { Injectable, TemplateRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface DialogData {
  title: string;
  message: string;
  /** Label of the single dismiss button. Defaults to `Close`. */
  okText?: string;
}

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  private dialogSource = new BehaviorSubject<DialogData | null>(null);
  dialog$ = this.dialogSource.asObservable();

  showDialog(data: DialogData) {
    this.dialogSource.next(data);
  }

  closeDialog() {
    this.dialogSource.next(null);
  }
}
